import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { profileRoute } from './profile/profile.route';

export const profileContainerRoute: RouteConfig = {
  path: '/profile',
  component: RouterView,
  children: [profileRoute],
  meta: {
    authorized: true,

    breadcrumb: {
      title: 'breadcrumbs.profiles.list',
      name: 'profiles'
    }
  }
};
